module.exports = __webpack_public_path__ + "img/c3-pop.0d96a1a5.png";